import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Content.css';

const Content = () => {
    return (
        <section className="about-content-sec">
            <Container>
                <Row>
                    <Col md={12} lg={8} lg={{ order: 2 }} className="text-center">
                        <div className="section-title">
                            <h1>About  Sushena Hospital</h1>
                        </div>
                        <p className="w-50 m-auto content-inner"><b style={{fontSize: '22px'}}>Sushena Hospital and <b style={{fontSize: '22px'}}>Raj Diagnostics</b></b> was founded by <b><u>Dr. Divya Verma</u></b> in the year 2015, This is among the few hospitals opened in Lucknow which openly take care of every individual patient trauma with the help of 24/7 staff members availability. They have been helping people with discounts and less fee structure. They are registered with the" Red Cross" and well equipped with all medical care facilities which enable us to become a destination of choice for healthcare seekers in India and abroad.</p>
                    </Col>
                </Row>

                <br />

                <Row>
                    <Col md={12} lg={8} lg={{ order: 2 }} className="text-center">
                        <div className="section-title">
                            <h1>About Doctor </h1>
                        </div>
                        <p className="w-50 m-auto content-inner"><b><u>Dr. Divya Verma</u></b> as ownership running hospital since 2014 with cooperation of look oriented and & patient Caring team nursing and paramedical staff" devoted Dr. Divya Verma having lifetime membership in the Red cross Society</p>
                    </Col>
                </Row>


            </Container>
        </section>
    );
};

export default Content;